import React from 'react';

const ContextData = React.createContext({
  CtxOrgName: ""
});

export default ContextData;